"use client"

import {usePathname} from "next/navigation";

export const FooterAddress = () => {
    const pathname = usePathname()
    if (!pathname.includes("support")) {
        return null
    }
    return <div
        className="font-bold pb-14 md:pb-6 text-lg text-hero-sky-545 text-center  mt-[75px] md:mt-[70px] -mb-[40px] md:mb-0  foAdd ">
        <span className="mr-1">Address:</span> Eisiskiu Sodu 18-oji g. 11,
        LT-02194, Vilnius, Lithuania
    </div>
}